import { useEffect, useState } from "react";

/** Ticks down to a fixed target instant (e.g. a lottery's drawTime), recomputed every second. */
const useCountdown = (target) => {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  const diff = Math.max(0, new Date(target || 0).getTime() - now);
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor(diff / 3600000) % 24,
    minutes: Math.floor(diff / 60000) % 60,
    seconds: Math.floor(diff / 1000) % 60,
    ended: diff === 0,
    closing: diff > 0 && diff <= 60000,
  };
};

export default useCountdown;
